import React, { useRef, useState, useEffect } from 'react';
import html2canvas from 'html2canvas';
import saucisseLogo from './saucisse.png';
import './CarteTerrains.css';

// Placer les images dans : src/components/stages/
// Noms attendus : final-destination.jpg, battlefield.jpg, small-battlefield.jpg,
//                 yoshis-story.jpg, hollow-bastion.jpg, pokemon-stadium-2.jpg,
//                 smashville.jpg, town-and-city.jpg, kalos.jpg

const STAGE_FILES = [
  { name: 'Final Destination', file: 'final-destination' },
  { name: 'Battlefield',       file: 'battlefield' },
  { name: 'Small Battlefield', file: 'small-battlefield' },
  { name: "Yoshi's Story",     file: 'yoshis-story' },
  { name: 'Hollow Bastion',    file: 'hollow-bastion' },
  { name: 'Pokémon Stadium 2', file: 'pokemon-stadium-2' },
  { name: 'Smashville',        file: 'smashville' },
  { name: 'Town & City',       file: 'town-and-city' },
  { name: 'Kalos',             file: 'kalos' },
];

function useStageImages() {
  const [images, setImages] = useState({});

  useEffect(() => {
    const loaded = {};
    let pending = STAGE_FILES.length;

    STAGE_FILES.forEach(({ file }) => {
      import(`./stages/${file}.jpg`)
        .then(mod => { loaded[file] = mod.default; })
        .catch(() => { loaded[file] = null; })
        .finally(() => {
          pending--;
          if (pending === 0) setImages({ ...loaded });
        });
    });
  }, []);

  return images;
}

const CarteTerrains = () => {
  const cardRef = useRef(null);
  const [exporting, setExporting] = useState(false);
  const stageImages = useStageImages();

  const handleExport = async () => {
    setExporting(true);
    try {
      await document.fonts.ready;
      const canvas = await html2canvas(cardRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: null,
        logging: false,
      });
      const link = document.createElement('a');
      link.download = 'saucistats-terrains.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (err) {
      console.error('Export failed:', err);
    } finally {
      setExporting(false);
    }
  };

  return (
    <>
      {window.location.hostname === 'localhost' && (
        <button
          onClick={handleExport}
          disabled={exporting}
          className="btn btn-outline-warning btn-sm ms-3"
        >
          <i className="bi bi-download me-1"></i>
          {exporting ? 'Export en cours...' : 'Exporter les terrains'}
        </button>
      )}

      <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
        <div ref={cardRef} className="carte-terrains">
          <div className="carte-terrains-header">
            <span className="carte-terrains-accent">&#9632;</span>
            <span className="carte-terrains-title">TERRAINS</span>
            <span className="carte-terrains-accent">&#9632;</span>
          </div>

          <div className="carte-terrains-ruleset">
            <span>3 stocks &bull; 7 min &bull; Hazards OFF</span>
          </div>

          <div className="carte-terrains-body">
            <div className="carte-terrains-grid">
              {STAGE_FILES.slice(0, 8).map((stage, idx) => (
                <div key={idx} className="carte-terrain-item">
                  <div className="carte-terrain-img-wrap">
                    {stageImages[stage.file] ? (
                      <img
                        src={stageImages[stage.file]}
                        alt={stage.name}
                        className="carte-terrain-img"
                        crossOrigin="anonymous"
                      />
                    ) : (
                      <div className="carte-terrain-placeholder">
                        <i className="bi bi-map"></i>
                      </div>
                    )}
                    <span className="carte-terrain-name">{stage.name}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="carte-terrain-last-row">
              <div className="carte-terrain-item">
                <div className="carte-terrain-img-wrap">
                  {stageImages[STAGE_FILES[8].file] ? (
                    <img
                      src={stageImages[STAGE_FILES[8].file]}
                      alt={STAGE_FILES[8].name}
                      className="carte-terrain-img"
                      crossOrigin="anonymous"
                    />
                  ) : (
                    <div className="carte-terrain-placeholder">
                      <i className="bi bi-map"></i>
                    </div>
                  )}
                  <span className="carte-terrain-name">{STAGE_FILES[8].name}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="carte-terrains-bottom-bar">
            <img src={saucisseLogo} alt="Saucismash" className="carte-brand-logo" />
            <span className="carte-terrains-label">1v1 Ruleset</span>
            <span className="carte-url">saucistats.com</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarteTerrains;
